/** Aligned to package.json "version" and reported in the `context` object of tracking events */
export const TRACKING_PLAN_VERSION = '1.5.4';
